import { useQuery } from "@tanstack/react-query";
import { GeneralSettingsService } from "modules/settings/services";
import { SETTINGS_PUBLIC_KEY } from "modules/settings/constants/queries";
import { useCallback } from "react";
import { IGeneralSettings } from "modules/settings/interfaces";

export const useFindOneGeneralCurrentPublicSettings = () => {
    const fetch = useCallback(() => GeneralSettingsService.getPublicSettings(), [])
    return useQuery<IGeneralSettings>([SETTINGS_PUBLIC_KEY], fetch);
}
